import { SidebarDemo, SidebarProvider } from "../components/ui/sidebar";
import { useAuth } from "../context/AuthContext";
import { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";

// Route wrapper components
export const AuthenticatedLayout = memo(function AuthenticatedLayout({ metaTitle = "" }) {
    const { user } = useAuth();
  
    if (!user) {
      return <Navigate to="/login" />;
    }
  
    return (
      <SidebarProvider>
        <div className="flex w-screen h-screen">
          <SidebarDemo />
          <main className="flex-1 overflow-y-auto bg-background flex-grow max-w-[calc(100vw-16rem)]">
            <Outlet />
          </main>
        </div>
      </SidebarProvider>
    );
  });